import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const shell = scrolled
    ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
    : 'bg-transparent border-b border-transparent';
  const textOnBar = scrolled ? 'text-foreground-950' : 'text-background-50';
  const linkColor = scrolled
    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
    : 'text-background-100 hover:text-background-50 hover:bg-white/15';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${shell}`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className={`flex items-center gap-2.5 whitespace-nowrap ${textOnBar}`}>
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-radar-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight">瓜田情报局</span>
            <span
              className={`mt-0.5 text-[10px] tracking-[0.18em] ${
                scrolled ? 'text-foreground-500' : 'text-background-200'
              }`}
            >
              持续更新 · 全程追踪
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-0.5 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${linkColor}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span
            className={`hidden items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium lg:flex ${
              scrolled
                ? 'border-primary-200 bg-primary-50 text-primary-700'
                : 'border-white/25 bg-white/10 text-background-50'
            }`}
          >
            <span className="flex h-3 w-3 items-center justify-center">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-soft-pulse" />
            </span>
            今日已更新 128 条
          </span>
          <a
            href="#live"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            蹲后续
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-md md:hidden ${
              scrolled ? 'text-foreground-950 hover:bg-background-200' : 'text-background-50 hover:bg-white/15'
            }`}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm font-medium text-foreground-800 last:border-0"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 flex w-full items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            爆料投稿
          </a>
        </div>
      )}
    </header>
  );
}